export default {
    name: "macro-menu-test-component",
    path: "macro-menu-test-component/",
    component: () => import(/* webpackChunkName: "app-components-entry" */ './macro.vue')
}